<ng-container *ngIf="vm$ | async as vm">
	<ui-section
		title="{{
			vm.mortgage.priority ? (vm.mortgage.priority | ordinalSuffix) : ''
		}} {{ headerTitle }}"
		[collapsable]="true"
	>
		<div section-content class="grid grid-cols-12 gap-4">
			<div class="col-span-4 flex flex-col gap-4">
				<ng-container *ngIf="vm.primaryLender; else noLender">
					<div>
						<p class="p-sm">Lender</p>
						<h5
							class="h5"
							*ngFor="let lender of vm.mortgage.lenders | keyvalue"
						>
							{{ lender.value.name || (lender.value.client | clientName) }}
						</h5>
					</div>
					<div *ngIf="vm.primaryLender | lenderLogoUrl" class="mb-6">
						<img
							[src]="
								'/assets/images/banks/' + (vm.primaryLender | lenderLogoUrl)
							"
							class="h-16 w-auto"
						/>
					</div>
				</ng-container>
				<ng-template #noLender>
					<div>
						<p class="p-sm">Lender</p>
						<h5 class="h5">No Lender</h5>
					</div>
				</ng-template>
			</div>
			<div class="col-span-8">
				<div
					class="mb-4 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-4 border-b pb-4"
				>
					<div class="space-y-2">
						<p class="p-sm">Principal Amount</p>
						<p class="p-sm font-medium text-gray-950">
							{{ vm.mortgage?.amount | centsToDollars }}
						</p>
					</div>
					<div class="space-y-2">
						<p class="p-sm">Interest Rate</p>
						<p class="p-sm font-medium text-gray-950">
							{{ vm.mortgage?.interestRateAsReg || vm.mortgage?.interestRate }}
						</p>
					</div>
					<div class="space-y-2">
						<p class="p-sm">Closing Date</p>
						<p class="p-sm font-medium text-gray-950">
							{{ closingDate$ | async | date }}
						</p>
					</div>
					<div class="space-y-2">
						<p class="p-sm">Loan Reference #</p>
						<p class="p-sm font-medium text-gray-950">
							{{ vm.mortgage?.referenceNumber }}
						</p>
					</div>
				</div>

				<div class="flex gap-10">
					<div class="space-y-2" *ngIf="fileType !== fileTypes.SALE">
						<ng-template
							*ngTemplateOutlet="
								borrowers;
								context: { clients: (matterClients$ | async) }
							"
						></ng-template>
					</div>

					<div class="space-y-2" *ngIf="fileType === fileTypes.SALE">
						<ng-template
							*ngTemplateOutlet="
								borrowers;
								context: { clients: (borrowers$ | async) }
							"
						></ng-template>
					</div>

					<ng-template #borrowers let-clients="clients">
						<p class="p-sm">Borrower{{ clients?.length > 1 ? 's' : '' }}</p>
						<div class="p-sm font-medium text-gray-950">
							<div class="flex flex-col gap-1">
								<div *ngFor="let client of clients">
									{{ client | clientName }}
								</div>
							</div>
						</div>
					</ng-template>
					<div
						*ngIf="
							vm.mortgage.source === MatterMortgageInstructionSource.ASSYST
						"
					>
						<a
							class="hover:underline flex gap-2 items-center text-sm text-green-600"
							externalNavInterceptor
							target="_blank"
							href="https://unity.doprocess.com/login/home"
						>
							<img
								class="w-14"
								src="assets/images/integrations/assyst-logo.svg"
							/>
							<div class="flex gap-2">
								<div>Open</div>
								<app-icon [icon]="ICON.EXTERNAL"></app-icon>
							</div>
						</a>
					</div>
					<div
						*ngIf="vm.mortgage.type === MatterMortgageType.LLC"
						class="flex flex-1 flex-col gap-4"
					>
						<div
							*ngIf="showMissingProperties()"
							class="flex flex-1 flex-col p-4 border border-orange-100 bg-orange-50 rounded-md min-w-[400px]"
						>
							<div class="flex flex-col flex-1 mb-8 gap-4">
								<div class="flex items-center text-xl gap-2">
									<app-icon
										[icon]="ICON.WARNING"
										class="text-orange"
									></app-icon>
									<h5 class="">Fire Insurance Data Sync Unavailable</h5>
								</div>
								<p class="text-gray-700 text-md">
									Add <em>{{ missingFireInsurancePropertiesString() }}</em> to
									matter before launching LLC
								</p>
							</div>

							<div
								class="hover:underline text-green-600 flex gap-2 text-sm items-center"
							>
								<app-anchor [url]="fireUrl" class="text-green-600"
									>Complete Information</app-anchor
								>
								<app-icon [icon]="ICON.RIGHT"></app-icon>
							</div>
						</div>
						<div
							class="flex flex-1 max-h-20 p-4 border border-gray-100 bg-gray-50 rounded-md"
						>
							<button
								class="hover:underline text-green-600 gap-2 flex items-center text-sm"
								(click)="handleGoToInstructions($event)"
								*ngIf="
									vm.mortgage?.status !== mortgageStatuses.CANCELLED;
									else isCancelled
								"
								logo
							>
								<div class="flex gap-2 text-md">
									<p>Launch LLC Portal</p>
									<app-icon [icon]="ICON.EXTERNAL"></app-icon>
								</div>
								<img
									src="/assets/images/integrations/llc-logo.svg"
									class="w-14"
								/>
							</button>
						</div>
					</div>
					<div
						*ngIf="vm.mortgage.type === MatterMortgageType.CLOSER_SYNC"
						class="mt-auto"
					>
						<ui-anchor (click)="handleGoToInstructions($event)"
							>Go to mortgage instructions</ui-anchor
						>
					</div>
				</div>
			</div>
		</div>
	</ui-section>
</ng-container>

<!-- <div class="space-y-4" *ngIf="mortgage">
	<div class="flex gap-8 bg-white rounded-xl p-6">
		<div class="flex flex-col gap-4">
			<ng-container *ngIf="(vm.mortgage?.lenders | keyvalue)?.[0]?.value as mortgageLender; else noLender">
				<div class="max-w-28 min-w-20 space-y-2">
					<span class="h3">{{mortgageLender.name}}</span>
					<div *ngIf="mortgageLender.logoUrl">
						<img [src]="'/assets/images/banks/' + mortgageLender.logoUrl" />
					</div>
				</div>
			</ng-container>
			<ng-template #noLender>
				<span class="h3">No Lender</span>
			</ng-template>
		</div>
		<div class="flex-grow">
			<div class="grid xl:grid-cols-2 grid-cols-1 gap-2 pb-4">
				<div class="flex flex-col gap-4">
					<ui-info-row infoLabel="Principal Amount" [infoValue]="vm.mortgage?.amount | centsToDollars" />
					<ui-info-row infoLabel="Closing Date">
						<ng-container *ngIf="closingDate$ | async as closingDate; else noDate">
							<span class="text-gray-500">{{closingDate | date}}</span>
						</ng-container>
						<ng-template #noDate>
							<span class="text-gray-500">-</span>
						</ng-template>
					</ui-info-row>
				</div>
				<div class="flex flex-col gap-4">
					<ui-info-row infoLabel="Loan Reference #" [infoValue]="vm.mortgage?.referenceNumber" />
					<ui-info-row infoLabel="Interest Rate" [infoValue]="vm.mortgage?.interestRateAsReg || vm.mortgage?.interestRate" />
				</div>
			</div>
			<div *ngIf="matterClients$ | async as matterClients" class="flex border-t pt-2">
				<ui-info-row
					infoLabel="Borrower{{matterClients.length > 1 ? 's' : ''}}"
				>
					<ng-container *ngFor="let client of matterClients; let last = last">
						<span>{{ client | clientName}}{{last ? '' : ', '}}</span>
					</ng-container>
				</ui-info-row>
			</div>
		</div>
        <ng-content select="[logo]"></ng-content>
	</div>
    <ng-content></ng-content>
</div> -->
